module.exports = __webpack_public_path__ + "img/saude.ffa1b359.svg";